import { Platform } from 'react-native';
import { createNavigationContainerRef } from '@react-navigation/native';
import { RootStackParamList } from '../types/navigation';

export const navigationRef = createNavigationContainerRef<RootStackParamList>();

/** Map tab names to URL section (path-only on web). Used so web never gets initialTab in URL. */
const initialTabToSection: Record<string, string> = {
  HomeTab: 'home',
  MoodBoardTab: 'mood-boards',
  ColourAnalysis: 'color-analysis',
  VirtualDrapeTest: 'virtual-drape-test',
  SmartWardrobe: 'smart-wardrobe',
  ColorGenerator: 'color-generator',
  ColorLibrary: 'color-library',
  ProfileTab: 'profile',
  SettingsTab: 'settings',
};

export function navigate(
  name: keyof RootStackParamList,
  params?: RootStackParamList[keyof RootStackParamList]
) {
  if (!navigationRef.isReady()) return;
  // Web: path-only URLs. When navigating to MainTabs, pass only section so URL stays clean.
  if (
    Platform.OS === 'web' &&
    name === 'MainTabs' &&
    params?.initialTab != null &&
    params?.section == null
  ) {
    const section = initialTabToSection[params.initialTab];
    if (section) {
      params = { ...params, section };
      delete params.initialTab;
    }
  }
  navigationRef.navigate(name as never, params as never);
}

export function reset(
  index: number,
  routes: Array<{
    name: keyof RootStackParamList;
    params?: RootStackParamList[keyof RootStackParamList];
  }>
) {
  if (navigationRef.isReady()) {
    try {
      navigationRef.reset({
        index,
        routes,
      });
    } catch {
      // Reset failed
    }
  }
}

export function getCurrentRoute() {
  if (navigationRef.isReady()) {
    return navigationRef.getCurrentRoute();
  }
  return null;
}

export function goBack() {
  if (navigationRef.isReady() && navigationRef.canGoBack()) {
    navigationRef.goBack();
  }
}
